export default "__VITE_ASSET__DOMidN_z__"